module.exports = __webpack_public_path__ + "static/jackpocket-ae6a528669e023e62235a9dc975bea43.jpg";